app.factory('dictionaryService', ['$q', '$translate', 'baseService', 'objectHelper', 'config',
    function ($q, $translate, baseService, objectHelper, config) {

        function DictionaryService() {

            this.getDictionaryElementsDataPage = function (code, criteria) {
                var d = $q.defer();

                baseService.post(config.API_URL + '/dictionaries/' + code + '/dataPage', criteria).then(
                    function (successResponse) {
                        if($translate.use() === 'de_DE') {
                            successResponse.data.forEach(function (element) {
                                if(element.englishValue) {
                                    element.value = element.englishValue
                                }
                                if(element.englishDescription) {
                                    element.description = element.englishDescription
                                }
                            });
                        }
                        var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
                        dataPage.data = objectHelper.translateArray(dataPage.data, DictionaryElementVO);

                        d.resolve(dataPage);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.saveDictionaryElement = function(dictionaryCode, dictionaryElement) {
                var d = $q.defer();

                baseService.post(config.API_URL + '/dictionaries/' + dictionaryCode, dictionaryElement).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, DictionaryElementVO);
                        d.resolve(data);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.updateDictionaryElement = function(dictionaryCode, dictionaryElement) {
                var d = $q.defer();

                baseService.put(config.API_URL + '/dictionaries/' + dictionaryCode + '/' + dictionaryElement.id, dictionaryElement).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, DictionaryElementVO);
                        d.resolve(data);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.deleteDictionaryElement = function(dictionaryCode, dictionaryElement) {
                var d = $q.defer();

                baseService.delete(config.API_URL + '/dictionaries/' + dictionaryCode + '/' + dictionaryElement.id).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, DictionaryElementVO);
                        d.resolve(data);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.getOrganizationalUnits = function (criteria) {
                var d = $q.defer();

                baseService.post(config.API_URL + '/dictionaries/ORGANIZATIONAL_UNIT/dataPage', criteria).then(
                    function (successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
                        dataPage.data = objectHelper.translateArray(dataPage.data, DictionaryOrganizationUnitVO);

                        d.resolve(dataPage);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

        }

        return new DictionaryService();
    }
]);
